import React from 'react';
import { Card, CardTitle, CardText } from 'react-md';
import { aladb } from 'db'
import _ from 'lodash'
import { Chart } from 'react-google-charts';

export default ({ N }) => {
	const sqlData = aladb.db.exec(`
		SELECT toDate(timestamp) as dt, COUNT(*) AS cnt FROM
		(SELECT timestamp FROM Log ORDER BY timestamp DESC)
		GROUP BY toDate(timestamp)
		LIMIT ${N}
	`);

	const data = [
		['Date', 'Count', { role: 'annotation' } ],
		..._.map(sqlData, v => [v.dt, v.cnt, v.cnt])
	];

	const options = {
		legend: "none",
		chartArea: {
			left: 40,
			right: 30,
			top: 10,
			bottom: 40,
		},
		hAxis: {
			format: 'd.M',
			gridlines: {count: 30, color: 'transparent'},
		},
	};

	return (
		<Card>
			<CardTitle title={`Abrufe in den letzten ${N} Tagen`}/>
			<CardText>
				<Chart
					chartType="ColumnChart"
					data={data}
					options={options}
					width="100%"
					height="200px"
					graph_id="chart-accessed-last-n-days"
				/>
			</CardText>
		</Card>
	);
};



// WEBPACK FOOTER //
// ./src/components/summary/cards/CardAccessedLastNDays.jsx